/**
 * Frontend Splide initialization for Slider block.
 */
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import './style.scss';

const initSliders = () => {
	document
		.querySelectorAll( '.cc-slider__splide.splide' )
		.forEach( ( sliderEl ) => {
			if ( sliderEl.dataset.splideMounted === 'true' ) {
				return;
			}

			const configRaw = sliderEl.getAttribute( 'data-splide-config' );

			if ( ! configRaw ) {
				return;
			}

			let config;

			try {
				config = JSON.parse( configRaw );
			} catch ( error ) {
				return;
			}

			// Splide only accepts a boolean for `arrows`. Custom controls sit outside the root.
			config.arrows = false;

			const root = sliderEl.closest( '.cc-slider' );
			const prevArrow = root?.querySelector( '.cc-slider__arrow--prev' );
			const nextArrow = root?.querySelector( '.cc-slider__arrow--next' );

			const splide = new Splide( sliderEl, config );
			splide.mount();
			sliderEl.dataset.splideMounted = 'true';

			if ( prevArrow && nextArrow ) {
				const updateArrowState = () => {
					const { Controller } = splide.Components;
					prevArrow.disabled = Controller.getPrev() < 0;
					nextArrow.disabled = Controller.getNext() < 0;
				};

				prevArrow.addEventListener( 'click', () => {
					splide.go( '<' );
				} );
				nextArrow.addEventListener( 'click', () => {
					splide.go( '>' );
				} );

				splide.on(
					'mounted moved refreshed scrolled endIndexChanged',
					updateArrowState
				);
				updateArrowState();
			}
		} );
};

document.addEventListener( 'DOMContentLoaded', initSliders );
